export default "__VITE_ASSET__CjDNkp$x__"